define('models/Recording',[
    'lib/knockout',
    'util/ObservableModel',
    'models/Annotation',
    'models/User'
], function (ko, ObservableModel, Annotation, User) {
    'use strict';

    var Recording = ObservableModel.extend({
        modelProperties: {
            annotations: Annotation,
            transcript: ObservableModel.extend({
                modelProperties: {
                    user: User
                }
            })
        },
        defaults: {
            annotations: []
        }
    }, function () {});

    return Recording;
});
